import { useController, UseControllerProps, useFormContext } from 'react-hook-form'

import { UseFormFieldProps, useFormField, FormField } from './FormField'
import { ButtonGroupProps } from '@/ui/Button'
import { ButtonGroup as Root } from '@/ui/Button'

type RootProps = Pick<ButtonGroupProps, 'options' | 'className'>

interface Props extends UseFormFieldProps, UseControllerProps, RootProps {
    name: string
}

export const ButtonGroup = ({ ...props }: Props) => {
    const { setValue } = useFormContext()
    const { formFieldProps, childProps } = useFormField(props)
    const { field } = useController({ control: props.control, name: props.name })

    const handleSelectValue = (value: boolean | string | number) => {
        setValue(props.name, value)
    }

    return (
        <FormField {...formFieldProps}>
            <Root onSelect={handleSelectValue} value={field.value} {...childProps} />
        </FormField>
    )
}
